<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import {ref, defineExpose, getCurrentInstance, nextTick } from "vue";
import { useRouter } from 'vue-router'
import { storeToRefs } from "pinia";
import Loading from 'vue3-loading-overlay';
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import {useUserStore} from "../../../stores/user";
import jobFairCorpService from "../../../services/jobFair/jobFairCorpService";
import JobFairJobNoticeModalBody from "./JobFairJobNoticeModalBody.vue";
import JobFairCorpApplicantResumeSelectModal from "./JobFairCorpApplicantResumeSelectModal.vue";
import JobFairApplyResumeConfirmModal from "@/pages/user/components/modal/jobFair/JobFairApplyResumeConfirmModal.vue";
import JobFairApplyResumeModal from "@/pages/user/components/modal/jobFair/JobFairApplyResumeModal.vue";
import JobFairResumeDetailModal from "@/pages/user/components/modal/jobFair/JobFairResumeDetailModal.vue";
import mypageJobFairJobNoticeService from "../../../services/mypage/jobFair/mypageJobFairJobNoticeService";
import mypageJobFairService from "../../../services/mypage/jobFair/mypageJobFairService";
import mypageJobFairApplicantService from "../../../services/mypage/jobFair/mypageJobFairApplicantService";
import JobFairCorpApplicantResumeUploadFileModal from "./JobFairCorpApplicantResumeUploadFileModal.vue";
import mypageJobFairResumeService from "../../../services/mypage/jobFair/mypageJobFairResumeService";
import JobFairReusmeCreatePolicyModal from "./JobFairReusmeCreatePolicyModal.vue";

const globals = getCurrentInstance().appContext.config.globalProperties;
const { alert, confirm: $confirm } = globals;

const router = useRouter();
const loadingStore = usePageLoadingStore()
const userStore = useUserStore();
const { user, isAuthenticated } = storeToRefs(userStore);

const baseModal = ref(null);
const resolvePromise = ref(null);
const resumeDetailModal = ref(null);
const resumeSelectModal = ref(null); // 이력서 보기
const applyResumeConfirmModal = ref(null); // 회사 이력서 안내
const resumeUploadFileModal = ref(null); // 회사 이력서 업로드
const jobFairReusmeCreatePolicyModal = ref(null); // 개인정보수집동의여부 모달

const isResumeSelectModalOpen = ref(false);
const isResumeDetailModalOpen = ref(false);
const isApplyResumeConfirmModalOpen = ref(false);
const isResumeUploadFileModalOpen = ref(false);

const modalBody = ref(null)
const modalContent = ref([])
const okButtonText = ref("네");
const cancelButtonText = ref("아니오");

const loaded = ref(false)

const isCorpMaster = ref(false); // 기업 마스터 여부
const isStudent = ref(false); // 학생/구직자 여부

const showButtons = ref(false);
const showPropsButtons = ref(false);
const hideFooterBtns = ref(false); // 하단 버튼 숨김 여부 추가
const noticeLikeTxts = ref("♡관심공고");
const interviewResumeIds = ref(0);
const resumeIds = ref(0)
const applicantCnts = ref(0);
const joinStateGbs = ref(0);
const jobNoticeSeqs = ref(0);
const inteYns = ref(false); // 관심공고 여부
const corpIds = ref(0);
const completeInteYns = ref(false);
const modes = ref(''); // mypage


const jobNoticeDetail = ref({});
const corpDetail = ref({});


let fileYns = ref("");
let appliedYn = ref(false); // 입사지원 여부
let applyStateBtn = ref("");

// 채용공고 보기
const retrieveJobNoticeDetail = (jobNoticeSeq) => {
  jobNoticeSeqs.value = jobNoticeSeq;
  loaded.value = false;

  if(jobNoticeSeq) {
    mypageJobFairJobNoticeService.retrieveJobNotice(jobNoticeSeq)
      .then((res) => {
        loaded.value = true;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          jobNoticeDetail.value = result;
          corpDetail.value = result.corporation;

          modalBody.value.setJobNotice(result);
          modalBody.value.setCorp(result.corporation);

          const userCorpId = user.value.userInfo.corporation.corpId;
          const userCorpMasterYn = user.value.userInfo.corpMasterYn;

          if((result.corpId === userCorpId) && userCorpMasterYn === 'Y') { // 기업마스터 여부
            isCorpMaster.value = true;
            isStudent.value = false;
          } else if(user.value.userInfo.userGb === 'STUDENT') { // 학생
            isCorpMaster.value = false;
            isStudent.value = true;
          }
        }
      })
      .catch( (error) =>  {
        loaded.value = true;
      });
  }
}

// 채용공고 관심여부
const retrieveInterestJobNoticeYn = (jobNoticeSeq) => {
  mypageJobFairService.retrieveInterestJobNoticeYn(jobNoticeSeq)
    .then((res) => {
      if(res.data.code.toLowerCase() === 'success') {
        inteYns.value = res.data.result === 'Y';
        noticeLikeTxts.value = inteYns.value ? "♥관심공고" : "♡관심공고";
      }
    })
    .catch( (error) =>  {
      inteYns.value = false;
    });
}

// 채용공고 수정
const onClickChangeJobNotice = (jobNoticeSeq, interviewResumeId) => {
  const resumeId = resumeIds.value;
  if (modes.value !== 'interview' || interviewResumeId || jobNoticeDetail.value.jobNoticeStateGb !== '02') {
    router.push({ name: 'MyPageCorpJobNotice', query : { jobNoticeSeq } })
  } else {
    router.push({ name: 'MyPageCorpJobNotice', query : { jobNoticeSeq, resumeId, mode: 'interview' } })
  }
}

// 채용공고 삭제
const onClickDelete = async (jobNoticeSeq) => {
  const ok = await $confirm(["채용공고를 삭제하시겠습니까?"], "삭제");
  if(ok) {
    mypageJobFairJobNoticeService.deleteJobNotice({ jobNoticeSeq })
      .then(async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === 'success') {
          await alert(["채용공고가 삭제되었습니다."]);
          cancel({ reload: true });
        } else {
          if (res.response.data.result.message) {
            alert([res.response.data.result.message]);
          } else {
            alert("채용공고 삭제를 실패하였습니다.");
          }
        }
      })
      .catch((res) => {
        loadingStore.loading = false;
        alert([res.response.data.result.message]);
      });
  }
}

// 면접제안
const onClickInterviewProposal = async (jobNoticeSeq, resumeId) => {
  const ok = await $confirm(["선택한 채용공고로", "면접제안을 하시겠습니까?"], "면접제안");
  if (!ok) {
    _confirm({ closeAll: true });
    return;
  }

  const paramObj = {
    jobNoticeSeq,
    resumeId
  };

  loadingStore.loading = true;
  mypageJobFairService.createInterviewProposalEntry(paramObj)
    .then(async (res) => {
      loadingStore.loading = false;
      if (res.data.code.toLowerCase() === 'success') {
        await alert(["면접제안을 하였습니다."]);
        _confirm({ jobNoticeSeq, interviewProposalYn: 'Y' });
      } else {
        alert(["면접제안을 실패하였습니다."]);
      }
    })
    .catch(() => {
      loadingStore.loading = false;
      alert(["면접제안을 실패하였습니다."]);
    });
}

const _confirm = (result) => {
  baseModal.value.close();
  resolvePromise.value(result || true);
};

// 관심공고 관심여부
const onClickLikeYn = async (jobNoticeSeq) => {
  const inteYn = inteYns.value ? 'N' : 'Y';
  const inteYnName = inteYn === 'Y' ? '등록' : '삭제';
  const ok = await $confirm([`관심공고${inteYn === 'Y' ? '로 ' : '를 '}${inteYnName}하시겠습니까?`], `관심공고 ${inteYnName}`, "취소");
  if(ok) {
    const paramObj = {
      jobNoticeSeq: jobNoticeSeq,
      interestNoticeYn: inteYn,
    };

    mypageJobFairService.updateInterestNoticeYn(paramObj)
      .then((res) => {
        if(res.data.code.toLowerCase() === 'success') {
          if (inteYn === 'Y') {
            alert([`${inteYnName}하였습니다.`]);
            noticeLikeTxts.value = "♥관심공고";
          } else {
            alert([`${inteYnName}하였습니다.`]);
            noticeLikeTxts.value = "♡관심공고";
          }
          inteYns.value = !inteYns.value;
        } else {
          alert([`${inteYnName} 실패하였습니다.`]);
        }
      })
      .catch( (res) =>  {
        alert([`${inteYnName} 실패하였습니다.`]);
      });
  }
}

// 입사지원 - 회사 이력서
const onClickCorpApplicant = (jobNoticeSeq) => {
  const paramObj = {
    jobNoticeSeq: jobNoticeSeq,
    userId: user.value.userId,
  };

  // 지원여부 확인
  mypageJobFairApplicantService.retrieveApplicantByUserId(paramObj)
    .then( async (res) => {
      loadingStore.loading = false;
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        appliedYn.value = result.length > 0;
        if(result.length) {
          alert(["이미 '입사지원'이 완료된 '채용공고'입니다."]);
          return;
        }

        if(jobNoticeDetail.value.fileYn === 'N') { // 협회이력서
          await onClickApplyResume();
        } else { // 회사이력서
          isApplyResumeConfirmModalOpen.value = true;
          await nextTick();
          const ok = await applyResumeConfirmModal.value.show();
          if(ok) { // 지원 계속하기
            const userId = user.value.userInfo.userCd;

            mypageJobFairService.retrieveRecruitPrivacyAgreeYnByUserId(userId)
              .then( async (res) => {
                if(res.data.code.toLowerCase() === 'success') {
                  const result = res.data.result;

                  if (result !== 'Y') { // 개인정보 이용 동의 내역이 없을때
                    const ok = await jobFairReusmeCreatePolicyModal.value.show();
                    if(ok) {
                      _createResumeFile();
                    }
                  } else {
                    _createResumeFile();
                  }
                }
              })
              .catch( (error) =>  {
                loadingStore.loading = false;
              });
          }
        }
      }
    })
    .catch( (res) =>  {
      loadingStore.loading = false;
    });
}

async function _createResumeFile(){
  isResumeUploadFileModalOpen.value = true;
  await nextTick();
  const result = await resumeUploadFileModal.value.show();
  if(result) {
    mypageJobFairResumeService.createResumeFile(result.result)
      .then((res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const paramObj = {
            jobNoticeSeq: jobNoticeDetail.value.jobNoticeSeq,
            resumeId: res.data.result,
          };
          createApplicant(paramObj);
        } else {
          alert(["입사지원을 실패하였습니다."]);
        }
      })
      .catch( (res) =>  {
        alert(["입사지원을 실패하였습니다."]);
      });
  }
}

// 이력서 상세 보기
const onShowResumeDetail = async (resumeId) => {
  isResumeDetailModalOpen.value = true;
  await nextTick();
  const result = await resumeDetailModal.value.show({
    jobNoticeSeq: jobNoticeDetail.value.jobNoticeSeq,
    resumeId,
    interestYn: 'N',
    showDeleteBtn: false,
    from: 'JobFairCorpApplicantResumeSelectModal',
  });

  if(result && result.resumeId) { // 입사지원 > 이력서 선택시
    const paramObj = {
      jobNoticeSeq: jobNoticeDetail.value.jobNoticeSeq,
      resumeId: result.resumeId,
    };
    createApplicant(paramObj);
    isResumeSelectModalOpen.value = false;
  } else {
    isResumeSelectModalOpen.value = false;
  }
}

// 입사지원
const onClickApplyResume = async () => {
  isResumeSelectModalOpen.value = true;
  await nextTick();
  const result = await resumeSelectModal.value.show({
    jobNoticeSeq: jobNoticeDetail.value.jobNoticeSeq,
  });
  if(result && result.resumeId) { // 입사지원 > 이력서 선택시
    const paramObj = {
      jobNoticeSeq: jobNoticeDetail.value.jobNoticeSeq,
      resumeId: result.resumeId,
    };
    createApplicant(paramObj);
    isResumeSelectModalOpen.value = false;
  } else {
    isResumeSelectModalOpen.value = false;
  }
}

const createApplicant = (paramObj) => {
  if(paramObj && paramObj.resumeId && paramObj.jobNoticeSeq) {
    mypageJobFairApplicantService.createApplicant(paramObj)
      .then((res) => {
        if(res.data.code.toLowerCase() === 'success') {
          alert([
            "입사지원을 하였습니다.",
            "<br/><br/>",
            "<span class='red'>지원 완료된 이력서는 수정이 불가하며,</span>",
            "<span class='red'>제출한 이력서를 변경하고 싶으신 경우</span>",
            "<span class='red'>입사지원 취소 후 새로운 이력서로 다시</span>",
            "<span class='red'>지원할 수 있습니다.</span>",
          ]);
          appliedYn.value = true;
        } else {
          alert(["입사지원을 실패하였습니다."]);
        }
      })
      .catch( (res) =>  {
        alert(["입사지원을 실패하였습니다."]);
      });
  }
}

const show = (params) => {
  const {
    showButton,
    showPropsButton,
    interviewResumeId,
    resumeId,
    inteYn,
    userCorpMasterYn,
    applicantCnt,
    joinStateGb,
    mode,
    jobNoticeSeq,
    corpId,
    hideFooterBtn = false,
  } = params;
  
  // 기본값 저장
  showButtons.value = showButton;
  showPropsButtons.value = showPropsButton;
  hideFooterBtns.value = hideFooterBtn; // 푸터 숨김 여부 적용

  modes.value = mode; // 마이페이지
  appliedYn.value = false;
  interviewResumeIds.value = interviewResumeId;
  resumeIds.value = resumeId; // 면접제안
  console.log(interviewResumeId, resumeId)
  
  // 채용공고 관리 및 지원 현황 목록에서 데이터 받음
  // applicantCnt, joinStateGb 조건에 따라 수정 버튼 작업
  applicantCnts.value = applicantCnt;
  joinStateGbs.value = joinStateGb;

  // 이력서 관리 및 입사지원 현황 > 입사지원
  if (applicantCnt === '지원함') {
    applyStateBtn.value = 'Y';
  }

  // inteYn 데이터가 있으면 'Y'로 데이터 변경
  // 관심공고 여부
  if (inteYn && inteYn === 'Y') {
    noticeLikeTxts.value = "♥관심공고"
  } else {
    noticeLikeTxts.value = "♡관심공고"
  }
  inteYns.value = inteYn === 'Y';

  // Matching > 특별채용관 > 채용공고에서 조건으로 데이터 전달 받았었는데
  // 조건이 변경 된 후로 사용 안함 20250527
  isCorpMaster.value = userCorpMasterYn;

  retrieveJobNoticeDetail(jobNoticeSeq);
  retrieveInterestJobNoticeYn(jobNoticeSeq);

  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const cancel = (options = {}) => {
  baseModal.value.close();
  resolvePromise.value({
    interestNoticeYn: inteYns.value ? 'Y' : 'N',
  });

  if (options.reload) {
    window.location.reload();
  }
};

defineExpose({
  show,
})
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <loading
        :active="!loaded"
        loader="dots"
        color="#3843AF"
        opacity="0.5"
        width="35"
        :is-full-page="false"></loading>
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body" v-show="loaded">
        <JobFairJobNoticeModalBody ref="modalBody"/>
      </div>
      <template v-if="!hideFooterBtns">
        <div class="modal-footer btn-wrap">
          <template v-if="isCorpMaster"> <!-- 기업 마스터 -->
            <div v-if="modes !== 'interview'" style="width: 100%; display: flex">
              <KSASecondaryButton v-if="jobNoticeDetail.applicantCnt === 0" text="삭제" class="red_button" @click="onClickDelete(jobNoticeSeqs)"/>
              <KSAPrimaryButton text="수정" @click="onClickChangeJobNotice(jobNoticeSeqs, modes)" style="margin-left: auto;"/>
            </div>
            <div v-else style="width: 100%; display: flex">
              <KSAPrimaryButton text="수정" @click="onClickChangeJobNotice(jobNoticeSeqs, interviewResumeIds, resumeIds)" />
              <KSAPrimaryButton v-if="jobNoticeDetail.jobNoticeStateGb === '02'" :text="interviewResumeIds ? '지원완료' : '선택'" @click="onClickInterviewProposal(jobNoticeSeqs, resumeIds)" :disabled="interviewResumeIds" style="margin-left: auto;" /> <!-- 면접제안 -->
            </div>
          </template>
          <template v-else-if="isStudent && jobNoticeDetail.jobNoticeStateGb !== '03'"> <!-- 학생/구직자 && 채용마감이 아닐때 -->
            <KSASecondaryButton :text="noticeLikeTxts" @click="onClickLikeYn(jobNoticeSeqs)" class="red_button"/> <!-- 관심공고 -->
            <KSAPrimaryButton v-if="jobNoticeDetail.jobNoticeStateGb === '02'" :text="appliedYn ? '지원완료' : '입사지원'" @click="onClickCorpApplicant(jobNoticeSeqs)" :disabled="appliedYn" /> <!-- 입사지원-->
          </template>
        </div>
      </template>
    </div>
  </Modal>
  <JobFairCorpApplicantResumeSelectModal v-if="isResumeSelectModalOpen" ref="resumeSelectModal" @show-resume-detail="onShowResumeDetail"/>
  <JobFairResumeDetailModal v-if="isResumeDetailModalOpen" ref="resumeDetailModal" />
  <JobFairApplyResumeConfirmModal v-if="isApplyResumeConfirmModalOpen" ref="applyResumeConfirmModal" :okButtonText="okButtonText" :cancelButtonText="cancelButtonText"/> <!-- 회사 이력서 안내 -->
  <JobFairCorpApplicantResumeUploadFileModal v-if="isResumeUploadFileModalOpen" ref="resumeUploadFileModal" /> <!-- 회사 이력서 입사지원 -->
  <JobFairReusmeCreatePolicyModal ref="jobFairReusmeCreatePolicyModal" />
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>
